import { forwardRef } from 'react'

import { SENTIMENT_BORDER } from './sentimentBorder'
import type { SentimentIconProps } from './types'

const FILL = 'var(--hsds-token-color-charcoal-600, #7E8E9E)'
const PATH =
  'M13.6571 2.34315C16.7813 5.46734 16.7813 10.5327 13.6571 13.6569C10.5329 16.781 5.46757 16.781 2.34337 13.6569C-0.780823 10.5327 -0.780823 5.46734 2.34337 2.34315C5.46757 -0.781049 10.5329 -0.781049 13.6571 2.34315ZM8.70733 4.46447C8.31681 4.07394 7.68364 4.07394 7.29312 4.46447C6.90259 4.85499 6.90259 5.48816 7.29312 5.87868L8.41455 7.00011H5.1718C4.61951 7.00011 4.17191 7.44772 4.17191 8C4.17194 8.55226 4.61953 8.99989 5.1718 8.99989H8.41455L7.29312 10.1213C6.90259 10.5118 6.90259 11.145 7.29312 11.5355C7.68364 11.9261 8.31681 11.9261 8.70733 11.5355L11.5358 8.70711C11.9263 8.31658 11.9263 7.68342 11.5358 7.29289L8.70733 4.46447Z'

// Neutral sentiment — charcoal circle with a rightward arrow. The `border`
// variant renders the same glyph in a 20×20 box behind a white border so it
// reads on colored backgrounds (mirrors the Figma `Border=True` asset).
const NeutralSentimentIcon = forwardRef<SVGSVGElement, SentimentIconProps>(
  function NeutralSentimentIcon({ border = false, ...rest }, ref) {
    if (border) {
      return (
        <svg
          ref={ref}
          width={20}
          height={20}
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...rest}
        >
          {SENTIMENT_BORDER}
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            transform="translate(2 2)"
            d={PATH}
            fill={FILL}
          />
        </svg>
      )
    }

    return (
      <svg
        ref={ref}
        width={16}
        height={16}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...rest}
      >
        <path fillRule="evenodd" clipRule="evenodd" d={PATH} fill={FILL} />
      </svg>
    )
  }
)

export { NeutralSentimentIcon }
